var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.125V16.5625C13.75 15.0062 15.0062 13.75 16.5625 13.75H18.125",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 13.75H23.4375C24.9938 13.75 26.25 15.0062 26.25 16.5625V18.125",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.5V23.4375C26.25 24.9938 24.9938 26.25 23.4375 26.25H22.5",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 26.25H16.5625C15.0062 26.25 13.75 24.9938 13.75 23.4375V21.875",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 18.4375V21.5625C23.125 22.8125 22.5 23.4375 21.25 23.4375H18.75C17.5 23.4375 16.875 22.8125 16.875 21.5625V18.4375C16.875 17.1875 17.5 16.5625 18.75 16.5625H21.25C22.5 16.5625 23.125 17.1875 23.125 18.4375Z",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 20H15.625",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9746 30.3815V33.0464C19.9746 33.3338 19.9136 33.591 19.7915 33.8183C19.6713 34.0455 19.4891 34.2258 19.245 34.3591C19.0009 34.4906 18.6938 34.5563 18.3238 34.5563C17.7961 34.5563 17.3942 34.4183 17.1182 34.1422C16.844 33.8643 16.7069 33.4953 16.7069 33.0352V30.3815H17.383V32.976C17.383 33.3197 17.4637 33.5732 17.6252 33.7366C17.7867 33.9 18.0281 33.9817 18.3492 33.9817C18.5708 33.9817 18.7511 33.9432 18.8901 33.8662C19.0309 33.7873 19.1342 33.6727 19.1999 33.5225C19.2675 33.3704 19.3013 33.1873 19.3013 32.9732V30.3815H19.9746ZM22.2254 30.3815C22.7569 30.3815 23.1447 30.4905 23.3888 30.7083C23.633 30.9262 23.755 31.2313 23.755 31.6238C23.755 31.8022 23.7269 31.9722 23.6705 32.1337C23.6161 32.2933 23.5259 32.4351 23.4001 32.5591C23.2743 32.6812 23.1081 32.7779 22.9015 32.8492C22.6968 32.9206 22.4442 32.9563 22.1437 32.9563H21.7043V34.5H21.0282V30.3815H22.2254ZM22.1803 30.9421H21.7043V32.3929H22.0733C22.2855 32.3929 22.4658 32.3685 22.6141 32.3196C22.7625 32.2689 22.8752 32.1891 22.9522 32.0802C23.0292 31.9713 23.0677 31.8276 23.0677 31.6492C23.0677 31.4107 22.9954 31.2332 22.8508 31.1168C22.708 31.0003 22.4846 30.9421 22.1803 30.9421ZM24.5776 34.5V30.3815H25.2537V34.5H24.5776Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 10V30C34.25 34.011 33.7617 36.2243 32.5778 37.487C31.4102 38.7325 29.3736 39.25 25.625 39.25H14.375C10.6264 39.25 8.58979 38.7325 7.42215 37.487C6.23833 36.2243 5.75 34.011 5.75 30V10C5.75 5.98902 6.23833 3.7757 7.42215 2.51296C8.58979 1.26748 10.6264 0.75 14.375 0.75H25.625C29.3736 0.75 31.4102 1.26748 32.5778 2.51296C33.7617 3.7757 34.25 5.98902 34.25 10Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.5H15",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiIcon);
export default __webpack_public_path__ + "static/media/upiIcon.42da0f77e7bf64cbd9a2ab0dac55a42a.svg";
export { ForwardRef as ReactComponent };